export default {
  // -----------------------------------------------------------------------------
  // Common translation entries
  // -----------------------------------------------------------------------------

  /* Nouns, Types, Terms, Phrases, etc... */
  yes: 'Yes',
  no: 'No',
  always: 'Always',
  never: 'Never',
  true: 'True',
  false: 'False',
  none: 'None',
  filters: 'Filters',
  actions: 'Actions',
  status: 'Status',
  additional_info: 'Additional info',
  search_placeholder_default: 'Search…',
  select_placeholder_default: 'Select…',
  description: 'Description',
  all: 'All',
  any: 'Any',
  this_and_that: '{0} and {1}',
  default: 'default',
  app_default: 'app default',
  sitewide: 'Sitewide',
  opens_in_a_new_tab: 'Opens in a new tab',
  details: 'Details',
  content: 'Content',
  tabs: 'Tabs',
  pulse: 'Pulse',
  history: 'History',
  summary: 'Summary',
  summary_data: 'Summary Data',
  summary_data_description: "Displays in Constellation's summary panel",
  supporting_data: 'Supporting Data',
  supporting_data_description: "Displays in Constellation's work area",
  heading: 'Heading',
  fields: 'Fields',
  subheading: 'Subheading',
  records: 'records',
  utilities: 'Utilities',
  utilities_description: "Displays in Constellation's Utility Panel",
  search: 'Search',
  menu: 'menu',
  new: 'New',
  info: 'info',
  shortcuts: 'Shortcuts',
  label: 'Label',
  required: 'required',
  caption: 'Caption',
  id: 'ID',
  name: 'Name',
  type: 'Type',
  icon: 'Icon',
  page: 'Page',
  default_input: 'Default input',
  default_input_value: 'Default input value',
  default_input_property: 'Default input property',
  value: 'Value',
  field: 'Field',
  field_group: 'Field Group',
  action: 'Action',
  view: 'View',
  range_input: 'range input',
  system: 'System',
  response: 'Response',
  rationale: 'Rationale',
  duration: 'Duration',
  tokens: 'Tokens',
  today: 'Today',
  verify_ai_generated_expression: 'Verify AI-generated content for accuracy.',
  custom: 'Custom',
  good: 'Good',
  caution: 'Caution',
  critical: 'Critical',
  similarity_score: 'Similarity score',
  workflow: 'Workflow',
  panel: 'Panel',
  other: 'Other',

  /* Verbs */
  remove: 'Remove',
  follow: 'Follow',
  unfollow: 'Unfollow',
  add: 'Add',
  cancel: 'Cancel',
  try_again: 'Try again',
  update: 'Update',
  submit: 'Submit',
  apply: 'Apply',
  select: 'Select',
  edit: 'Edit',
  preview: 'Preview',
  decline: 'Decline',
  delete: 'Delete',
  close: 'Close',
  activate: 'Activate',
  expand: 'Expand',
  collapse: 'Collapse',
  accept: 'Accept',
  clear: 'Clear',
  use: 'Use',
  undo: 'Undo',
  redo: 'Redo',
  filter: 'Filter',
  sort: 'Sort',
  group: 'Group',
  go: 'Go',
  configure: 'Configure',
  dismiss: 'Dismiss',
  due: 'Due',
  drag: 'Drag',
  resize: 'Resize',
  reset: 'Reset',
  refresh: 'Refresh',
  copy: 'Copy',
  explain: 'Explain',
  generate: 'Generate',
  reject: 'Reject',
  modify: 'Modify',
  start: 'Start',
  stop: 'Stop',
  regenerate: 'Regenerate',
  generation_failed: 'Generation failed.',
  retry: 'Retry',

  /* Static verb noun */
  view_all: 'View all',
  view_less: 'View less',
  show_more: 'Show more',
  show_less: 'Show less',
  show_all: 'Show all',
  clear_all: 'Clear all',
  clear_selection: 'Clear selection',
  link_open_in_tab_text: 'Open in tab',
  edit_details: 'Edit details',
  add_emoji: 'Add emoji',
  create_new: 'Create new',
  submit_and_open: 'Submit and open',
  add_condition: 'Add condition',
  enter_fullscreen: 'Enter fullscreen',
  exit_fullscreen: 'Exit fullscreen',
  disable_word_wrap: 'Disable word wrap',
  enable_word_wrap: 'Enable word wrap',
  expand_search: 'Expand search',

  /* Dynamic verb {noun} */
  open_noun: 'Open {0}',
  close_noun: 'Close {0}',
  view_all_noun: 'View all {0}',
  view_less_noun: 'View less {0}',
  expand_noun: 'Expand {0}',
  add_noun: 'Add {0}',
  collapse_noun: 'Collapse {0}',
  configure_noun: 'Configure {0}',
  checked_noun: '{0} checked',
  selected_noun: '{0} selected',
  unselected_noun: '{0} unselected',
  use_input_value: 'Use {0}',
  preview_of_noun: 'Preview of {0}',
  go_to_noun: 'Go to {0}',
  insert_noun: 'Insert {0}',
  delete_noun: 'Delete {0}',
  remove_noun: 'Remove {0}',
  loading_noun: 'Loading {0}…',
  create_noun: 'Create {0}',
  choose_noun: 'Choose {0}',
  select_noun: 'Select {0}',
  resize_noun: 'Resize {0}',
  search_noun: 'Search {0}',

  /* Contextual actions label */
  actions_for: 'Actions - {0}',

  /* States */
  edited: 'Edited {0}',
  deleted: '{0} deleted',
  done: 'Done',
  uploading: 'Uploading',
  loading: 'Loading…',
  loaded: 'Loaded',
  submitting: 'Submitting…',
  no_items: 'No items',
  unknown_error: 'Unknown error',
  image_load_error: 'Error loading image',
  selected: 'Selected',
  not_selected: 'Not selected',
  selected_count: {
    zero: '{0} selected',
    one: '{0} selected',
    two: '{0} selected',
    few: '{0} selected',
    many: '{0} selected',
    other: '{0} selected'
  },
  completed: 'Completed',
  current: 'Current',
  previous: 'Previous',
  not_started: 'Not started',
  empty_value: 'Empty value',
  no_value: 'no value',
  delivered: 'Delivered',
  sent: 'Sent',
  active: 'Active',
  read_only: 'Read only',
  information: 'Information',
  error: 'Error',
  errors: {
    zero: 'Errors',
    one: 'Error',
    two: 'Errors',
    few: 'Errors',
    many: 'Errors',
    other: 'Errors'
  },
  warning: 'Warning',
  success: 'Success',
  pass: 'Pass',
  fail: 'Fail',
  did_not_ask: 'Did not ask',
  created: 'Created',
  results_for: 'Results for {0}',
  opening_noun: 'Opening {0}',
  characters_typed: 'characters typed',
  processing: 'Processing',
  copied_to_clipboard: 'Copied to clipboard',
  failed_to_copy: 'Failed to copy',
  viewing: 'Viewing',
  editing: 'Editing',

  /* Date and time */
  day_placeholder: 'DD',
  month_placeholder: 'MM',
  year_placeholder: 'YYYY',
  hour_placeholder: 'hh',
  minute_placeholder: 'mm',
  second_placeholder: 'ss',
  meridiem_value_am: 'AM',
  meridiem_value_pm: 'PM',
  week_placeholder: 'WW',
  seconds_text: 'Seconds',
  minutes_text: 'Minutes',
  hours_text: 'Hours',
  days_text: 'Days',
  time_text: 'Time',
  time_format_info: 'hh:mm:ss',
  date_quarter_q1: 'Q1 {0}',
  date_quarter_q2: 'Q2 {0}',
  date_quarter_q3: 'Q3 {0}',
  date_quarter_q4: 'Q4 {0}',
  time_unit: 'Time Unit',

  /* Count based types */
  attachments_count: {
    zero: 'No attachments',
    one: '{0} attachment',
    two: '{0} attachments',
    few: '{0} attachments',
    many: '{0} attachments',
    other: '{0} attachments'
  },
  results_count: {
    zero: 'No results',
    one: '{0} result',
    two: '{0} results',
    few: '{0} results',
    many: '{0} results',
    other: '{0} results'
  },
  recent_results_count: {
    zero: 'No recent results',
    one: '{0} recent result',
    two: '{0} recent results',
    few: '{0} recent results',
    many: '{0} recent results',
    other: '{0} recent results'
  },
  new_emails_count: {
    zero: 'No new emails',
    one: '{0} new email',
    two: '{0} new emails',
    few: '{0} new emails',
    many: '{0} new emails',
    other: '{0} new emails'
  },

  /* Pagination */
  pagination_page_of: 'Page {0} of {1}',
  pagination_next: 'Next',
  pagination_prev: 'Previous',

  /* Range */
  range_from_datetime: 'Since',
  range_to_datetime: 'Until',
  range_from_numeric: 'From',
  range_to_numeric: 'To',

  /* Error messages */
  error_field_unavailable: 'Field {0} is unavailable',
  error_field_list_unavailable: 'Fields {0} are unavailable',

  /* Miscellaneous */
  x_of_y: '{0} of {1}',
  n_more: '{0} more',
  keypress_instruction: 'Press {0} to {1}',

  // -----------------------------------------------------------------------------
  // {pkg}:{ComponentDir} entries
  // -----------------------------------------------------------------------------

  /* core:TextArea */
  text_area_characters_remaining: 'Less than {0} characters remaining.',
  text_area_character_limit: 'Maximum character limit reached.',

  /* core:Link */
  preview_link_instruction: 'Press {0} and p to open this link in a preview.',

  /* core:LiveLog */
  polite_announcements: 'Polite Announcements',
  assertive_announcements: 'Assertive Announcements',

  /* core:SkipLinks */
  go_to_main_content: 'Go to main content',
  main_content: 'Main content',

  /* core:KeyboardCommands */
  general: 'General',
  tables_and_grids: 'Tables and grids',
  keyboard_commands: 'Keyboard commands',
  key_combination: 'Key combination',
  shortcut_NavigateCells: 'Grid navigation: Move to cell',
  shortcut_EnterTabNav: 'Interactive items or form input in cell: Switch to Tab navigation',
  shortcut_TabNavigation: 'Tab navigation: Move through interactive items',
  shortcut_RestoreGridNav: 'Restore Grid navigation',

  /* core:AIRewrite */
  ai_rewrite_title: 'Rewrite with AI',
  ai_rewrite_label: 'How would you like to rewrite your content?',
  ai_rewrite_improve: 'Improve writing',
  ai_rewrite_shorter: 'Shorten',
  ai_rewrite_professional: 'Make more professional',
  ai_rewrite_friendly: 'Make more friendly',
  ai_rewrite_instructions_label: 'Additional instructions',
  ai_rewrite_instructions_info: 'Example: "Translate to English (UK)" or "Keep under 50 words"',
  ai_rewrite_generate: 'Generate',
  ai_rewrite_result_label: 'Suggestion',

  /* core:AppShell */
  app_shell_create: 'Create',
  app_shell_open_nav: 'Open navigation menu',
  app_shell_more: 'More',
  app_shell_main_navigation_label: 'Main',
  shortcut_NextRegion: 'Next region',
  shortcut_PrevRegion: 'Previous region',
  shortcut_KeyboardCommands: 'Keyboard commands',
  app_shell_user_account: 'Account',
  app_shell_pin: 'Pin',
  app_shell_unpin: 'Unpin',
  application_logo: 'Application logo',
  theme_mode: 'Theme mode',
  theme_light: 'Light',
  theme_dark: 'Dark',
  theme_system: 'System',
  app_shell_share: 'Share',

  /* core:AppHeader */
  app_header_help: 'Help',

  /* core:ComboBox */
  combobox_open_close: 'Arrow down to open, press escape to close.',
  combobox_search_instructions: 'Start typing to search',
  combobox_open_list_button_a11y: 'Open combobox list',
  combobox_close_list_button_a11y: 'Close combobox list',
  multiselect_instructions: 'Arrow {0} from start to review selected items',
  multiselect_instructions_with_links: 'Shift+Tab, then arrow {0} to review selected items',
  selected_items: 'Selected items',

  /* core:CompositeInput */
  composite_input_open_button_a11y: 'Open configuration dialog',
  composite_input_close_button_a11y: 'Close configuration dialog',

  /* core:ListToolbar */
  list_toolbar_add_view: 'Add customized view',

  /* core:Menu */
  menu_selection_instructions: 'Press enter to select items.',
  menu_filter_instructions: 'Start typing to filter.',
  menu_item_expand_arrow: '{0}. Arrow right to expand.',
  menu_item_collapse_arrow: 'Arrow left to collapse.',
  menu_item_collapse_shift_space: 'Press shift space to collapse.',
  menu_item_shift_space_expand_collapse: '{0}. Press shift space to expand and collapse.',
  menu_option_list: 'Options list',
  menu_item_count: 'Contains {0} items.',
  menu_collapsed: '{0} collapsed',
  menu_expanded: '{0} expanded.',

  /* core:Modal */
  modal_minimize: 'Minimize modal',
  modal_maximize: 'Maximize modal',
  modal_dock: 'Dock modal',
  modal_close: 'Close modal',
  minimize: 'Minimize',
  maximize: 'Maximize',
  dock: 'Dock',

  /* core:MultiStepForm */
  step_num: 'Step {0} of {1}',
  steps: 'Steps',

  /* core:Tree */
  load_more: 'Load more',

  /* core:Datetime */
  selected_date_a11y: 'Selected date:',
  open_calendar_button_a11y: 'Open calendar',
  close_calendar_button_a11y: 'Close calendar',
  open_time_button_a11y: 'Open time picker',
  close_time_button_a11y: 'Close time picker',
  set_current_date_and_time_a11y: 'Set to now',
  set_current_date_a11y: 'Set to today',
  clear_current_date_and_time: 'Clear current date and time',
  clear_current_date: 'Clear current date',
  clear_current_time: 'Clear current time',
  picker_next_month: 'Next month',
  picker_prev_month: 'Previous month',
  picker_jump_to_month_and_year: 'Jump to month and year selection',
  calendar_assist: 'Use cursor keys to navigate dates',
  calendar: 'Calendar',
  choose_date: 'Choose date',
  choose_date_and_time: 'Choose date and time',
  choose_week: 'Choose week',
  set_current_week_ally: 'Set to current week',
  auto_focus_next_input_description:
    'Automatically moves focus to next input when current input is completed.',
  year_input_description: 'You may also enter a four-digit year manually.',

  /* core:Boolean */
  boolean_display_true_label: 'Yes',
  boolean_display_false_label: 'No',

  /* core:MultiStepForm */
  step_changed_to_name: 'Step changed to {0}',
  go_to_previous_step: 'Go to previous step - {0}',
  jump_to_step_restricted: 'Navigation to "{0}" is restricted.',

  /* core:Number */
  measured_in: 'measured in {0}',
  increase_value_by: 'Increase value by {0}',
  decrease_value_by: 'Decrease value by {0}',
  stepper_instructions: 'To set the value use the up and down arrow keys or type the value',

  /* core:Banner */
  banner_dismiss_button_label_a11y: 'Dismiss banner',

  /* core:File */
  file_upload_text_main: 'Drop or {0}',
  file_upload_text_one: 'choose a file',
  file_upload_text_multiple: 'choose files',
  download_file: 'Download {0}',
  preview_file: 'Preview {0}',
  open_file_in_new_tab: 'Open {0} in new tab',
  upload_failed: '{0} upload failed with {1}',
  uploading_file: 'uploading {0}',
  number_of_items: {
    zero: 'No items',
    one: '{0} item',
    two: '{0} items',
    few: '{0} items',
    many: '{0} items',
    other: '{0} items'
  },
  no_file_chosen: 'No file chosen',
  attach_files: 'Attach files',
  attach_review: 'Attach or review',
  files_uploaded: {
    zero: 'No files uploaded',
    one: '{0} file uploaded successfully',
    two: '{0} files uploaded successfully',
    few: '{0} files uploaded successfully',
    many: '{0} files uploaded successfully',
    other: '{0} files uploaded successfully'
  },
  files_upload_failed: {
    zero: 'No files failed to upload',
    one: '{0} file failed to upload',
    two: '{0} files failed to upload',
    few: '{0} files failed to upload',
    many: '{0} files failed to upload',
    other: '{0} files failed to upload'
  },
  download_all: 'Download all',

  /* core:Location */
  my_current_location_button_a11y: 'Use my current location',
  location_input_placeholder: 'Enter a location',
  location_not_found_text: 'Location not found',
  exact_location: 'Exact location',
  allow_location_permissions_text:
    'To get current location, allow location permissions for this app',
  location_info: 'Location info',

  /* core:SearchInput */
  advanced_search: 'Advanced search',
  recent_searches: 'Recent searches',
  search_instructions: 'Use arrow keys to move up and down the suggested results.',
  search_in: 'Search in',
  search_in_noun: 'Search in {0}',

  /* core:SummaryList */
  action_from_summarylist_heading: '{0} - {1}',
  selected_search_filter: 'Filter search by: {0}',

  /* work:CaseView */
  utilities_label: 'Utilities',
  utilities_summary: 'Utilities summary',
  expand_summary: 'Expand summary',
  collapse_summary: 'Collapse summary',
  expand_utilities_panel: 'Expand utilities',
  collapse_utilities_panel: 'Collapse utilities',
  primary_summary_fields: 'Primary summary fields',
  summary_fields: 'Summary fields',
  case_type_icon: '{0} - icon',
  case_type: 'Case type',
  case_image: 'Case image',
  case_tabs: 'Tabs for current case',
  case_followed: 'Followed {0}',
  case_unfollowed: 'Unfollowed {0}',
  update_available: 'Update available',
  case_work_area: 'Case work area',

  /* work:CasePreview */
  close_preview: 'Close preview',
  preview_error: 'Unable to load preview',
  case_preview_tabs: 'Tabs for previewed case',

  /* work:GenAICoach */
  agent_switcher: '{0}, agent switcher',
  message_pega_gen_ai_coach: 'Your message',
  write_message: 'Write a message',
  ai_disclaimer: 'Verify AI-generated content for accuracy.',
  suggestions: 'Suggestions',
  you: 'You',
  agent: 'Agent',
  chat_with_ai: 'Chat with AI',
  close_chat_with_ai: 'Close - Chat with AI',
  agent_noun: '{0} agent',
  welcome_text: 'How can I assist you today?',
  start_chat: 'Start chat',
  starter_message: 'Starter message',
  ask_coach: 'Ask {0}',
  working_on_request: 'Working on the request...',
  thinking: 'Thinking',
  analyzing_data_sources: 'Analyzing data sources',
  generating_response: 'Generating response',
  generation_stopped: 'Response stopped',
  fullscreen: 'Fullscreen',
  new_chat: 'New chat',
  double_checking_results: 'Double checking results',
  finalizing_response: 'Finalizing response',
  preparing_content: 'Preparing content',
  response_generated: 'Response generated',
  processing_speech: 'Processing speech',
  good_response: 'Good response',
  bad_response: 'Bad response',
  share_feedback: 'Share feedback',
  interaction_message:
    'Press Enter to focus interactive elements within the message, Tab to move between them, and Escape to return to the message list',
  pega_genAI: 'Pega GenAI',
  suggestions_in_message: 'with {0} suggestions',
  you_asked: 'You asked {0}',
  no_conversations_found: 'No conversations found',
  conversation: 'Conversation',
  back: 'Back',
  add_attachment: 'Add attachment',
  attachment_upload_in_progress: 'Attachment upload in progress',
  attachment_added: 'Attachment added',
  send_message: 'Send message',
  tool_decision: 'Decision',
  current_action: 'Current action',
  modify_details: 'Modify details',
  confirm_details: 'Confirm details',
  current_details: 'Current details {0}',
  semantic_discovery_results: 'Semantic discovery results',
  reasoning_disclaimer:
    'Multiple candidates were considered in helping generate this response. This table shows what was considered, why it was considered, how closely it matched your request and whether it was selected.',
  candidates: 'Candidates',
  agent_message: 'Agent message',
  user_message: 'User message',
  active_cases: 'Active cases',
  active_cases_trigger: 'Active cases, {0} open',
  your_chats: 'Your chats',
  reset_width: 'Reset width',

  /* core:FormField */
  accept_suggestion_button_a11y: 'Accept AI suggestion',
  reject_suggestion_button_a11y: 'Reject AI suggestion',
  suggestion_info: 'Accept AI suggestion?',
  suggestion_assist:
    'Either press Enter to accept the AI suggestion or edit the value to reject it',

  /* core:Phone Input */
  country_code: 'Country code',
  phone_number: 'Phone number',
  select_country_code: 'Select country code',
  enter_a_number: 'Enter a number',

  /* core:SkipLinks */
  skip_navigation_menu_label: 'Skip navigation menu',

  /* core:Tabs */
  tab_error_description: 'Has errors',
  tab_error_tooltip: '{0} has errors',
  all_tabs: 'All tabs',
  return_to_tab_list: 'Return to tab list',

  /* core:LightBox */
  non_previewable: "{0} file can't be previewed",
  large_non_previewable: "Large {0} file can't be previewed",
  content_load_error: 'Error loading content',
  description_unavailable: 'Description unavailable',

  /* core:Toaster */
  shortcut_JumpToToast: 'Jump to toast',
  shortcut_DismissToast: 'Dismiss toast',

  /* core: PageTemplates */
  configurable_layout_instructions:
    'Configurable layout. Use tab key to select an item. Use arrow keys to move it to a new position. Use arrow keys with shift to resize the item in the given direction.',
  page_number: 'Page {0}',

  /* core:SpeechToTextButton */
  dictate: 'Dictate',
  stop_dictation: 'Stop dictation',

  /* core:SpeechRecognition */
  no_speech_detected: 'No speech was detected. Please try speaking again.',
  no_microphone_found: 'No microphone was found. Please check your audio input.',
  microphone_access_denied: 'Microphone access was denied. Please allow access and try again.',
  speech_recognition_error: 'Speech recognition error: {0}',
  speech_recognition_not_supported: 'Speech recognition is not supported in this browser.',

  /* dnd:DragHandle */
  drag_handle_activate_description: 'Press Control + Space to activate dragging.',
  drag_handle_drop_description: 'Press Control + Space to drop item.',
  drag_handle_cancel_description: 'Press Escape to cancel.',
  drag_handle_vertical_description: 'Use Alt + Arrow keys to drag up or down.',
  drag_handle_horizontal_description: 'Use Alt + Arrow keys to drag left or right.',
  drag_handle_tab_description: 'Use Tab and Shift Tab to drag to adjacent lists.',

  /* dnd:StandardDragDropList */
  remove_button_description: 'Click to remove the list item',
  list_item_control_instructions: 'Has interactive controls',
  list_item_nav_instructions:
    'Use the up and down arrow keys to navigate between items. Press Enter to enter tabbing mode and access elements within the list',

  /* work:Assignments */
  assignments: 'Assignments',

  /* work:Hierarchial Assignment */
  case: 'Case',
  assignment: 'Assignment',
  assignment_item_assignee: 'Assignee:',
  assignment_item_urgency: 'Urgency:',
  assignment_announcement_label: 'Assignment:',
  case_announcement_label: 'Case: {0}',
  assignments_go_announcement_label: 'Go - {0}',
  assignments_sla: 'Due {0}',
  key_navigation_instruction:
    'Use Enter key to navigate by Tab. Escape to navigate using arrow keys. Recommend using focus mode in screen reader for optimal experience.',

  /* work:ArticleList */
  article_list_label_a11y: 'Article list',
  article_list_filter_label_a11y: 'Article lists filter',
  article_list_header_submit_label: 'Submit',
  clear_filters: 'Clear filters',
  suggest_article: 'Suggest article',
  suggested: 'Suggested',
  followed: 'Followed',
  buddy: 'Buddy',
  disclaimer: 'Disclaimer',
  references: 'References',
  result_available: 'Result available',
  ask: 'Ask',
  error_message: 'Unable to retrieve data at the moment. Please try again.',
  add_a_comment: 'Add a comment',
  score: 'Score {0}',
  relevance_score: 'Relevance score {0}',
  ai_suggestions: 'AI suggestions',
  ai_suggestion: 'AI suggestion',
  auto_answered: 'Auto answered',
  questions_detected: 'Questions detected',
  past_answered_questions: 'Past answered questions',
  not_relevant_questions: 'Not relevant questions',
  back_to_ai_suggestions: 'Back to AI suggestions',
  confidence: 'Confidence',
  ask_buddy: 'Ask buddy',
  ai_generated: 'AI generated',
  no_articles_found: 'No articles found',
  semantic_initial_message: 'Search results will appear here',
  confirmation_options: 'Confirmation options',
  search_filter: 'Filters - search articles',
  articles_found: '{0} articles found',

  /* work:Article */
  article_label_a11y: 'Article',
  article_related_links: 'Related links',
  article_more_like_this: 'More like this',
  article_thank_you_for_your_feedback: 'Thank you for your feedback.',
  article_attachments: 'Attachments',
  likes: 'Likes',
  dislikes: 'Dislikes',
  like: 'Like',
  dislike: 'Dislike',

  /* work:Confirmation */
  confirmation_whats_next: "What's next",
  confirmation_open_tasks: 'Open tasks',

  /* work:SearchResults */
  search_results_clear_all_filters: 'Clear all filters',
  search_results_clear_filter: 'Clear {0} filter',
  search_results_active_filters: 'Active filters',
  search_filter_update_message: 'Modifying filters will update search results',

  /* work:Stakeholders */
  add_stakeholders: 'Add stakeholder',
  edit_stakeholder: 'Edit stakeholder',
  view_stakeholders: 'Stakeholders',
  stakeholders_role: 'Role',
  stakeholders: {
    zero: '{0} stakeholders',
    one: '{0} stakeholder',
    two: '{0} stakeholders',
    few: '{0} stakeholders',
    many: '{0} stakeholders',
    other: '{0} stakeholders'
  },

  /* work:Tags */
  edit_tags: 'Edit tags',
  tags: 'Tags',

  /* work:Glimpse */
  view_profile: 'View profile',

  /* work:AppAnnouncement */
  app_announcement_dismiss_button_label_a11y: 'Hide until next update',
  app_announcement_details_list_header: 'Announcements',
  app_announcement_whats_new_button_label: "See what's new",

  /* work:Stages */
  stages_label: 'Case stages',
  stages_see_full_lifecycle: 'See full lifecycle',
  stages_case_lifecycle: '{0} lifecycle',
  stages_default_case_lifecycle: 'Case lifecycle',
  stages_stage_label: 'Stage {0}, {1}',
  stages_description: 'Use horizontal arrow keys to navigate.',

  /* work:Predictions */
  predictions: 'Predictions',
  all_predictions: 'All predictions',
  learn_more: 'Learn more',

  /* work:TaskList */
  tasks: 'Tasks',
  tasks_added: {
    zero: 'No tasks added',
    one: '{0} task added',
    two: '{0} tasks added',
    few: '{0} tasks added',
    many: '{0} tasks added',
    other: '{0} tasks added'
  },
  tasks_removed: {
    zero: 'No tasks removed',
    one: '{0} task removed',
    two: '{0} tasks removed',
    few: '{0} tasks removed',
    many: '{0} tasks removed',
    other: '{0} tasks removed'
  },

  /* work:InteractionNotification */
  interaction_time_expired: 'The time to accept the interaction has expired.',
  interaction_time_remaining: {
    zero: 'The time to accept the interaction has expired.',
    one: '{0} second remaining to accept the interaction.',
    two: '{0} seconds remaining to accept the interaction.',
    few: '{0} seconds remaining to accept the interaction.',
    many: '{0} seconds remaining to accept the interaction.',
    other: '{0} seconds remaining to accept the interaction.'
  },
  interaction_shortcut_goto_info: 'Press {0} to review.',
  interaction_shortcut_dismiss_info: 'Press {0} to dismiss.',
  shortcut_GoToIncomingInteraction: 'Go to incoming interaction popup.',
  shortcut_DismissIncomingInteraction: 'Dismiss incoming interaction popup.',

  /* rte:RichTextEditor */
  rte_heading_style: 'Heading style',
  rte_heading_style_normal: 'Normal',
  rte_heading_style_heading_1: 'Heading 1',
  rte_heading_style_heading_2: 'Heading 2',
  rte_heading_style_heading_3: 'Heading 3',
  rte_heading_style_heading_4: 'Heading 4',
  rte_heading_style_unknown: 'Unknown',
  rte_bold: 'Bold',
  rte_italic: 'Italic',
  rte_strike_through: 'Strike-through',
  rte_cut: 'Cut',
  rte_copy: 'Copy',
  rte_paste: 'Paste',
  rte_bulleted_list: 'Bulleted list',
  rte_numbered_list: 'Numbered list',
  rte_indent: 'Indent',
  rte_unindent: 'Unindent',
  rte_table: 'Table',
  rte_link: 'Link',
  rte_link_text: 'Text',
  rte_link_url: 'URL',
  rte_image: 'Insert image',
  rte_invalid_html: 'Invalid HTML',
  rte_insert_field: 'Insert field',
  rte_invalid_url: 'Invalid URL',
  rte_change_text_format: 'Change text format to',
  rte_toggle_unordered_list: 'Toggle unordered list',
  rte_indent_selection: 'Indent selection',
  rte_unindent_selection: 'Unindent selection',
  rte_toolbar_instructions: 'Hit tab to enter the editor toolbar',
  rte_text_formatting_toolbar: 'Text formatting toolbar',
  rte_image_description_info: 'Alternate (ALT) description for those with visual impairment',
  rte_image_custom_size: 'Custom size',
  rte_width_in_pixels: 'Width (in pixels)',
  rte_height_in_pixels: 'Height (in pixels)',
  rte_image_settings: 'Image settings',
  rte_edit_image: 'Edit image {0}',
  rte_delete_image: 'Delete image {0}',
  rte_image_key_command: 'Press enter to edit the image',
  rte_image_source: 'Source',
  rte_image_file: 'File',
  rte_image_link: 'Link',
  rte_image_url: 'URL',
  rte_empty_image: 'File is required',
  rte_broken_image: 'File could not be loaded',
  rte_add_image: 'Add image',
  rte_action_url: 'Action URL',

  /* social:Email */
  important: 'Important',
  expand_trail: 'Expand trail',
  collapse_trail: 'Collapse trail',
  copy_to: 'Copy to',
  subject_label: 'Subject: {0}',
  search_results: 'Search results',
  get_next_email: 'Get next email',
  mark_email_as_important: 'Mark email as important',
  email_attachment: '{0} with {1}',

  /* social:Feed */
  feed_post_type: 'Post type',
  feed_new_post: 'Message',
  feed_new_post_submit: 'Post',
  feed_new_comment: 'New comment',
  feed_new_comment_submit: 'Comment',
  feed_attach_files: 'Attach files',
  feed_post_actions_menu: 'More',
  feed_edit_post: 'Edit post',
  feed_edit_comment: 'Edit comment',
  feed_edit_posted: 'Post edited',
  feed_edit_commented: 'Comment edited',
  feed_context: 'in {0}',
  feed_liked_by: 'Liked by {0}',
  feed_likes: 'Likes',
  feed_visibility: 'Visibility',
  feed_private: 'Private',
  feed_public: 'Public',
  feed_visible_to: 'Visible to',
  feed_users: 'Users',
  feed_mode: 'Mode',
  feed_like_label: 'Like',
  feed_unlike_label: 'Unlike',
  feed_post_likes: {
    zero: 'No likes',
    one: '{0} like',
    two: '{0} likes',
    few: '{0} likes',
    many: '{0} likes',
    other: '{0} likes'
  },
  feed_comment_label: 'Comment',
  feed_post_comments: {
    zero: 'No comments',
    one: '{0} comment',
    two: '{0} comments',
    few: '{0} comments',
    many: '{0} comments',
    other: '{0} comments'
  },
  feed_attachments_added: {
    zero: 'No attachments added',
    one: '{0} attachment added',
    two: '{0} attachments added',
    few: '{0} attachments added',
    many: '{0} attachments added',
    other: '{0} attachments added'
  },
  feed_attachments_removed: {
    zero: 'No attachments removed',
    one: '{0} attachment removed',
    two: '{0} attachments removed',
    few: '{0} attachments removed',
    many: '{0} attachments removed',
    other: '{0} attachments removed'
  },
  feed_post_liked: 'Post has been liked',
  feed_post_deliked: 'Post has been deliked',
  feed_post_removed: 'Post has been removed',
  feed_comment_added: 'Comment added',
  feed_comment_removed: 'Comment removed',
  showing_num_of_num: 'Showing {0} of {1}',
  feed_new_post_added: {
    zero: 'No posts added',
    one: '{0} post added',
    two: '{0} posts added',
    few: '{0} posts added',
    many: '{0} posts added',
    other: '{0} posts added'
  },
  new_item_added: {
    zero: 'No items added',
    one: '{0} new item added',
    two: '{0} new items added',
    few: '{0} new items added',
    many: '{0} new items added',
    other: '{0} new items added'
  },
  loading_post: 'Loading post',
  mention_type: 'Mention a {0}',
  markdown_syntax: 'Markdown syntax',
  markdown_instructions: 'Add special characters around your text to apply formatting.',
  markdown_styles: 'Style',
  markdown_images: 'Images',
  markdown_links: 'Links',
  markdown_lists: 'Lists',
  markdown_headings: 'Headings',
  markdown_code: 'Code',
  markdown_code_block: 'Code block',
  markdown_bold: 'Bold',
  markdown_italic: 'Italic',
  markdown_blockquote: 'Blockquote',
  markdown_heading_level: 'Heading {0}',
  markdown_ordered_list: 'Ordered list',
  markdown_ordered_sublist: 'Ordered sublist',
  markdown_unordered_list: 'Unordered list',
  markdown_unordered_sublist: 'Unordered sublist',
  markdown_link_text: 'Link text',
  markdown_link_url: 'Link url',
  markdown_alt_text: 'Alt text',
  markdown_image_url: 'Image url',

  /* social:AISummary */
  generating_summary: 'Generating summary',
  summary_generation_failed: 'Summary generation failed',
  summary_generated: 'Summary generated',

  /* cs:Chat */
  scroll_to_latest_message: 'Scroll to latest message',
  scroll_to_unread_messages: 'Scroll to unread messages',
  suggested_replies_current_of_total: 'Suggested reply {0} of {1}',
  suggested_replies: 'Suggested replies',
  confidence_percentage: '{0}% confidence',
  next_suggested_reply: 'Next suggested reply',
  prev_suggested_reply: 'Previous suggested reply',
  dismiss_suggested_replies: 'Dismiss suggested replies',
  message_sent: 'Message sent',
  temporarilyUnavailable: 'Temporarily unavailable',
  available: 'Available',
  unavailable: 'Unavailable',
  authenticated: 'Authenticated',
  not_authenticated: 'Not authenticated',
  context: 'Context',
  context_data: 'Context data',
  bot: 'Bot',
  is_typing: '{0} is typing {1}',
  chat_message_at_timestamp: '{0} at {1}.',
  sender_replied_message: '{0} replied {1}',
  chat_attachments: '{0} with {1} attachments',
  chat_links: '{0} with {1} links',
  chat_message_status: 'Message {0}',
  opened: 'Opened',
  undeliverable: 'Undeliverable',
  new_message: 'New message',
  attachments: 'attachments',
  attachments_x_of_y: 'attachment {0} of {1}',
  edit_current_template: 'Edit suggested reply {0} of {1}',
  send_current_template: 'Send suggested reply {0} of {1}',
  expand_suggested_replies: 'Expand suggested replies',
  collapse_suggested_replies: 'Collapse suggested replies',
  replies_count: '{0} of {1}',
  no_suggestion: 'No suggestions',
  suggestion: 'Suggestion',
  suggested_reply_copied_to_input_field: 'Suggested reply copied to input field',
  dialogue: 'Dialogue',
  suggest_reply: 'Suggest reply',
  join_conversation: 'Join conversation',

  /* cs:Email */
  unique_entities: {
    zero: 'No unique entities',
    one: '{0} unique entity',
    two: '{0} unique entities',
    few: '{0} unique entities',
    many: '{0} unique entities',
    other: '{0} unique entities'
  },
  more_count: '{0} more…',
  other_responses: 'Other responses',
  empty_search: 'Enter a search term',
  new_messages: 'New messages',
  earlier_transcripts: 'Earlier transcripts',
  send: 'Send',
  compose_label: 'Compose',
  save_as_draft: 'Save as draft',
  enter_message: 'Enter message',
  download: 'Download',
  close_chat_utility: 'Close chat utility',
  email_account: 'Email account',
  subject: 'Subject',
  to: 'To',
  from: 'From',
  cc: 'Cc',
  bcc: 'Bcc',
  date: 'Date',
  reply: 'Reply',
  reply_all: 'Reply all',
  response_templates: 'Response templates',
  forward: 'Forward',
  email: 'Email',
  email_message: 'Email message',
  email_filters: 'Email filters',
  unread_email_count: '{0} of {1} unread',
  priority: 'Priority',
  inbox: 'Inbox',
  insert: 'Insert',
  email_add_attachment: 'Add attachment',
  email_add_attachment_count: 'Add attachment, the maximum number of attachments allowed is {0}.',
  email_disable_attachment:
    'Adding attachments are disabled, the maximum number of attachments allowed is {0}.',
  email_remove_attachment: 'Remove attachment',
  loading_email: 'Loading email',
  draft: {
    zero: 'No drafts',
    one: '{0} draft',
    two: '{0} drafts',
    few: '{0} drafts',
    many: '{0} drafts',
    other: '{0} drafts'
  },
  undelivered: 'Undelivered',
  drafts: 'drafts',
  unread: 'unread',
  mailing_details: 'mailing details',

  /* cs:CallControlPanel */
  call_panel_heading: 'Pega call',
  call_panel_make_new_call: 'Make new call',
  call_panel_agent_status: 'Status',
  call_panel_pause_call_menu_item: 'Pause call',
  call_panel_resume_call_menu_item: 'Resume call',
  call_panel_mute_mic_menu_item: 'Mute microphone',
  call_panel_unmute_mic_menu_item: 'Unmute microphone',
  call_panel_call_on_hold: 'On hold {0}',
  call_panel_consult_call_menu_item: 'Consult',
  call_panel_transfer_call_menu_item: 'Transfer',
  call_panel_menu_item_call_only: 'Call only',
  call_panel_menu_item_call_with_interaction: 'Call and interaction',
  call_panel_send_dtmf_menu_item: 'Send DTMF',
  call_panel_conference_call_menu_item: 'Conference',
  call_panel_hangup_call_menu_item: 'Hang up',
  call_panel_disconnect_participant: 'Disconnect participant',
  call_panel_contacts_add_to_favorites: 'Add to favorites',
  call_panel_contacts_remove_from_favorites: 'Remove from favorites',
  call_panel_contacts_call_button_label: 'Call',
  call_panel_contacts_list_heading: 'Contacts',
  call_panel_contacts_favorites_heading: 'Favorites',
  call_panel_contacts_dial_pad_heading: 'Dial pad',
  call_panel_new_call_heading: 'New call',
  call_panel_interaction_transfer_heading: 'Transfer initiated',
  call_panel_interaction_transfer_complete_button_label: 'Complete transfer',
  call_panel_incoming_call: 'Incoming call…',
  call_panel_answer_call: 'Answer',
  call_panel_reject_call: 'Reject',

  call_panel_conference_heading: 'Conference call',
  call_panel_conference_call_and_interactions_heading: 'Conference by call and interaction',
  call_panel_consult_heading: 'Consult by call',
  call_panel_consult_call_and_interactions_heading: 'Consult by call and interaction',
  call_panel_transfer_heading: 'Transfer call',
  call_panel_transfer_call_and_interactions_heading: 'Transfer call and interaction',

  call_panel_conference_submit: 'Conference',
  call_panel_transfer_submit: 'Transfer',
  call_panel_consult_submit: 'Consult',

  call_panel_handover_reason_label: 'Reason',
  call_panel_handover_to_label: 'To',
  call_panel_handover_comments_label: 'Comments',
  call_panel_handover_call_option_label: 'Call option',
  call_panel_handover_call_only_option: 'Call only',
  call_panel_handover_call_and_interaction_option: 'Call and interaction',
  call_panel_handover_interaction_label: 'Interaction',
  call_panel_merge_call_menu_item: 'Merge',
  call_panel_handoff_call_menu_item: 'Hand off',
  call_panel_send_dtmf_heading: 'Send DTMF',
  call_panel_expand: 'Expand call control panel',
  call_panel_collapse: 'Collapse call control panel',
  call_panel_nav_label: 'Phone panel',

  /* cs:DialPad */
  dial_pad_keyboard: 'Dial pad keyboard',
  dial_pad_phone_number_input_label: 'Phone number input',
  dial_pad_call_button_label: 'Call {0}',

  /* cs:VerbatimParagraph */
  attestation_statement: 'I attest that I have spoken this as written',
  script_adherence_error: 'Dialog should be adhered to before submission',

  /* cs:TaskManager */
  accept_all: 'Accept all',
  select_multiple: 'Select multiple',
  dismiss_case: 'Dismiss case',
  task_manager_add_case: 'Add case',
  task_manager_wrap_up: 'Wrap up',
  task_manager_cases: 'Cases',
  add_cases: 'Add cases',
  open_cases: 'Open cases',
  resolved_cases: 'Resolved cases',
  no_picker_items: 'No {0}',
  selected_picker_items: 'Selected {0}',
  no_selected_picker_items: 'No selected {0}',
  search_picker_items: 'Search {0}',
  case_picker_close: 'Close case picker',
  case_manager_overflow_menu: 'All cases',
  continue_label: 'Continue',
  continue_label_a11y: 'Continue with {0}',
  review_label: 'Review',
  review_label_a11y: 'Review {0}',
  dismiss_label: 'Dismiss',
  dismiss_label_a11y: 'Dismiss {0}',
  task_manager_picker_add_label: {
    zero: 'No items to add',
    one: 'Add {0} new item',
    two: 'Add {0} new items',
    few: 'Add {0} new items',
    many: 'Add {0} new items',
    other: 'Add {0} new items'
  },
  detected_entities_label: {
    zero: 'No entities detected',
    one: '{0} entity detected',
    two: '{0} entities detected',
    few: '{0} entities detected',
    many: '{0} entities detected',
    other: '{0} entities detected'
  },
  show_detected_entities: 'Show detected entities',
  nothing_detected_yet: 'Nothing detected yet',
  ai_detected_entities: 'AI detected entities',
  close_conversation: 'Close conversation',
  shortcut_AddTask: 'Open task picker',
  shortcut_WrapUp: 'Wrap up interaction',
  close_interaction: 'Close interaction',
  live_transcript: 'Live transcript',
  open_live_transcript: 'Open live transcript',
  close_live_transcript: 'Close live transcript',
  download_live_transcript: 'Download live transcript',
  transcripts: 'Transcripts',
  verbatim: 'Verbatim',
  dialog: 'Dialog',
  download_transcript: 'Download transcript',
  follow_up_tasks: 'Follow-up tasks',
  add_follow_up_task: 'Add follow-up task',
  agents_utterance: "Agent's commitment in context",
  task_deleted: 'Deleted',
  entity_auto_fill_announcement_message:
    'Some fields in the current assignment form have been auto populated',

  /* cs:FeedbackMetrics */
  no_analytics_collected: 'No analytics were collected during this interaction',
  feedback_not_available: 'Feedback not available',

  /* cs:FollowUpTask */
  due_on: 'Due on {0}',

  /* cs:InteractionSummary */
  interaction_summary: 'Interaction summary',
  edit_interaction_summary: 'Edit interaction summary',
  cancel_editing_interaction_summary: 'Cancel editing interaction summary',
  save: 'Save',
  save_interaction_summary: 'Save interaction summary',
  reason_for_transfer: 'Reason for transfer',
  reason_cannot_be_blank: 'Reason for transfer cannot be blank',
  ai_suggested_summary: 'AI suggested summary',
  summary_cannot_be_blank: 'Summary cannot be blank',
  interaction_Summary_not_available: 'Interaction summary not available',

  /* cs:Sentiment */
  sentiment_positive: 'Positive',
  sentiment_negative: 'Negative',
  sentiment_neutral: 'Neutral',

  /* cs:IntelligentGuidance */
  no_recommendations: 'No recommendations',
  items_added_to_previous_list: 'Items added to previous list',
  items_added_to_current_list: 'Items added to current list',

  /* condition-builder:ConditionBuilder */
  condition_builder_advanced_condition_label: 'Advanced condition',
  condition_builder_advanced_condition_placeholder: 'Advanced condition',
  condition_builder_advanced_mode_button_label: 'Advanced mode',
  condition_builder_basic_mode_button_label: 'Basic mode',
  condition_builder_advanced_mode_button_aria_label: 'Switch to advanced mode',
  condition_builder_basic_mode_button_aria_label: 'Switch to basic mode',
  condition_builder_mode_switch: 'Mode switched',
  condition_builder_advanced_condition_tooltip:
    'A logical expression representing an advanced condition. Use numbers like 1,2,3,… to represent different condition rows. Use {0} operators and parentheses to construct advanced conditions. Example: {1}',
  condition_builder_condition_select_info_default: 'No selection',
  condition_builder_possible_values_label: 'Values',
  condition_builder_possible_values_error: 'Error retrieving values',
  condition_builder_multi_selection_placeholder: 'Select values',
  condition_builder_single_selection_placeholder: 'Select value',
  condition_builder_switch_banner_text:
    'Switching from advanced mode can reset all AND/OR/NOT operators. Do you want to continue?',
  condition_builder_confirm_button_label: 'OK',
  condition_builder_empty_selection_error_text: 'No selection',
  condition_builder_empty_value_text: 'Empty value',
  condition_builder_compare_with: 'Compare with {0}',
  condition_builder_compare_with_another_field: 'Another field',
  condition_builder_compare_with_parameter: 'Parameter',
  condition_builder_compare_with_relative_date: 'Relative date',
  condition_builder_compare_with_text_value: 'Text value',
  condition_builder_compare_with_numeric_value: 'Numeric value',
  condition_builder_compare_with_date_value: 'Date value',
  condition_builder_compare_with_time_value: 'Time value',
  condition_builder_invalid_time_period: 'Invalid time period',
  condition_builder_invalid_relative_date: 'Invalid relative date',
  condition_builder_invalid_value: 'Invalid value',
  condition_builder_invalid_values: 'Invalid values',
  condition_builder_invalid_time: 'Invalid time',
  condition_builder_invalid_date: 'Invalid date',
  condition_builder_invalid_number: 'Invalid number',
  condition_builder_invalid_date_range: 'Invalid date range',
  condition_builder_invalid_time_range: 'Invalid time range',
  condition_builder_invalid_number_range: 'Invalid range',
  condition_builder_select_placeholder: 'Select…',
  condition_builder_row: 'Row {0}',
  condition_builder_hour_number_of_day: '{0} (hour of day)',
  condition_builder_rhs_with_time_only_input: 'Rhs with Time only input',
  condition_builder_rhs_with_date_only_input: 'Rhs with Date only input',
  condition_builder_rhs_with_date_time_input: 'Rhs with Date Time input',
  condition_builder_rhs_with_csv_input: 'Rhs with csv input',
  condition_builder_no_selection: 'No selection',
  condition_builder_enter_csv_placeholder: 'Enter comma separated values',
  condition_builder_day_number_of_month: {
    zero: '{0}th day of the month',
    one: '{0}st day of the month',
    two: '{0}nd day of the month',
    few: '{0}rd day of the month',
    many: '{0}th day of the month',
    other: '{0}th day of the month'
  },
  condition_builder_year: 'Year(s)',
  condition_builder_quarter: 'Quarter(s)',
  condition_builder_month: 'Month(s)',
  condition_builder_week: 'Week(s)',
  condition_builder_day: 'Day(s)',
  condition_builder_hour: 'Hour(s)',
  condition_builder_minute: 'Minute(s)',
  condition_builder_second: 'Second(s)',
  condition_builder_date_function_hour_of_day: 'Hour of day',
  condition_builder_date_function_month_of_year: 'Month of year',
  condition_builder_date_function_day_of_month: 'Day of month',
  condition_builder_date_function_day_of_week: 'Day of week',
  condition_builder_date_part: 'Date part',
  condition_builder_current_second: 'Current second',
  condition_builder_current_minute: 'Current minute',
  condition_builder_current_hour: 'Current hour',
  condition_builder_current_day: 'Current day',
  condition_builder_current_week: 'Current week',
  condition_builder_current_month: 'Current month',
  condition_builder_current_quarter: 'Current quarter',
  condition_builder_current_year: 'Current year',
  condition_builder_last_X_seconds: {
    zero: 'Current second',
    one: 'Last second',
    two: 'Last {0} seconds',
    few: 'Last {0} seconds',
    many: 'Last {0} seconds',
    other: 'Last {0} seconds'
  },
  condition_builder_last_X_minutes: {
    zero: 'Current minute',
    one: 'Last minute',
    two: 'Last {0} minutes',
    few: 'Last {0} minutes',
    many: 'Last {0} minutes',
    other: 'Last {0} minutes'
  },
  condition_builder_last_X_hours: {
    zero: 'Current hour',
    one: 'Last hour',
    two: 'Last {0} hours',
    few: 'Last {0} hours',
    many: 'Last {0} hours',
    other: 'Last {0} hours'
  },
  condition_builder_last_X_days: {
    zero: 'Current day',
    one: 'Last day',
    two: 'Last {0} days',
    few: 'Last {0} days',
    many: 'Last {0} days',
    other: 'Last {0} days'
  },
  condition_builder_last_X_weeks: {
    zero: 'Current week',
    one: 'Last week',
    two: 'Last {0} weeks',
    few: 'Last {0} weeks',
    many: 'Last {0} weeks',
    other: 'Last {0} weeks'
  },
  condition_builder_last_X_months: {
    zero: 'Current month',
    one: 'Last month',
    two: 'Last {0} months',
    few: 'Last {0} months',
    many: 'Last {0} months',
    other: 'Last {0} months'
  },
  condition_builder_last_X_quarters: {
    zero: 'Current quarter',
    one: 'Last quarter',
    two: 'Last {0} quarters',
    few: 'Last {0} quarters',
    many: 'Last {0} quarters',
    other: 'Last {0} quarters'
  },
  condition_builder_last_X_years: {
    zero: 'Current year',
    one: 'Last year',
    two: 'Last {0} years',
    few: 'Last {0} years',
    many: 'Last {0} years',
    other: 'Last {0} years'
  },
  condition_builder_next_X_seconds: {
    zero: 'Current second',
    one: 'Next second',
    two: 'Next {0} seconds',
    few: 'Next {0} seconds',
    many: 'Next {0} seconds',
    other: 'Next {0} seconds'
  },
  condition_builder_next_X_minutes: {
    zero: 'Current minute',
    one: 'Next minute',
    two: 'Next {0} minutes',
    few: 'Next {0} minutes',
    many: 'Next {0} minutes',
    other: 'Next {0} minutes'
  },
  condition_builder_next_X_hours: {
    zero: 'Current hour',
    one: 'Next hour',
    two: 'Next {0} hours',
    few: 'Next {0} hours',
    many: 'Next {0} hours',
    other: 'Next {0} hours'
  },
  condition_builder_next_X_days: {
    zero: 'Current day',
    one: 'Next day',
    two: 'Next {0} days',
    few: 'Next {0} days',
    many: 'Next {0} days',
    other: 'Next {0} days'
  },
  condition_builder_next_X_weeks: {
    zero: 'Current week',
    one: 'Next week',
    two: 'Next {0} weeks',
    few: 'Next {0} weeks',
    many: 'Next {0} weeks',
    other: 'Next {0} weeks'
  },
  condition_builder_next_X_months: {
    zero: 'Current month',
    one: 'Next month',
    two: 'Next {0} months',
    few: 'Next {0} months',
    many: 'Next {0} months',
    other: 'Next {0} months'
  },
  condition_builder_next_X_quarters: {
    zero: 'Current quarter',
    one: 'Next quarter',
    two: 'Next {0} quarters',
    few: 'Next {0} quarters',
    many: 'Next {0} quarters',
    other: 'Next {0} quarters'
  },
  condition_builder_next_X_years: {
    zero: 'Current year',
    one: 'Next year',
    two: 'Next {0} years',
    few: 'Next {0} years',
    many: 'Next {0} years',
    other: 'Next {0} years'
  },
  condition_builder_previous_X_seconds: {
    zero: 'Current second',
    one: 'Previous second',
    two: 'Previous {0} seconds',
    few: 'Previous {0} seconds',
    many: 'Previous {0} seconds',
    other: 'Previous {0} seconds'
  },
  condition_builder_previous_X_minutes: {
    zero: 'Current minute',
    one: 'Previous minute',
    two: 'Previous {0} minutes',
    few: 'Previous {0} minutes',
    many: 'Previous {0} minutes',
    other: 'Previous {0} minutes'
  },
  condition_builder_previous_X_hours: {
    zero: 'Current hour',
    one: 'Previous hour',
    two: 'Previous {0} hours',
    few: 'Previous {0} hours',
    many: 'Previous {0} hours',
    other: 'Previous {0} hours'
  },
  condition_builder_previous_X_days: {
    zero: 'Current day',
    one: 'Previous day',
    two: 'Previous {0} days',
    few: 'Previous {0} days',
    many: 'Previous {0} days',
    other: 'Previous {0} days'
  },
  condition_builder_previous_X_weeks: {
    zero: 'Current week',
    one: 'Previous week',
    two: 'Previous {0} weeks',
    few: 'Previous {0} weeks',
    many: 'Previous {0} weeks',
    other: 'Previous {0} weeks'
  },
  condition_builder_previous_X_months: {
    zero: 'Current month',
    one: 'Previous month',
    two: 'Previous {0} months',
    few: 'Previous {0} months',
    many: 'Previous {0} months',
    other: 'Previous {0} months'
  },
  condition_builder_previous_X_quarters: {
    zero: 'Current quarter',
    one: 'Previous quarter',
    two: 'Previous {0} quarters',
    few: 'Previous {0} quarters',
    many: 'Previous {0} quarters',
    other: 'Previous {0} quarters'
  },
  condition_builder_previous_X_years: {
    zero: 'Current year',
    one: 'Previous year',
    two: 'Previous {0} years',
    few: 'Previous {0} years',
    many: 'Previous {0} years',
    other: 'Previous {0} years'
  },
  condition_builder_time_period_label: 'Time period',
  condition_builder_time_period_last: 'Last',
  condition_builder_time_period_current: 'Current',
  condition_builder_time_period_previous: 'Previous',
  condition_builder_time_period_next: 'Next',
  condition_builder_value_label: 'Value',
  condition_builder_field_label: 'Field',
  condition_builder_comparator_label: 'Conditional operator',
  condition_builder_comparator_is_true: 'is true',
  condition_builder_comparator_is_false: 'is false',
  condition_builder_comparator_is_equal_to: 'is equal to',
  condition_builder_comparator_is_not_equal_to: 'is not equal to',
  condition_builder_comparator_is_null: 'is null',
  condition_builder_comparator_is_not_null: 'is not null',
  condition_builder_comparator_is_in_list: 'is in list',
  condition_builder_comparator_is_not_in_list: 'is not in list',
  condition_builder_comparator_starts_with: 'starts with',
  condition_builder_comparator_not_starts_with: 'not starts with',
  condition_builder_comparator_ends_with: 'ends with',
  condition_builder_comparator_not_ends_with: 'not ends with',
  condition_builder_comparator_contains: 'contains',
  condition_builder_comparator_not_contains: 'not contains',
  condition_builder_comparator_between: 'between',
  condition_builder_comparator_not_between: 'not between',
  condition_builder_comparator_greater_than: 'greater than',
  condition_builder_comparator_greater_than_or_equals: 'greater than or equals',
  condition_builder_comparator_lower_than: 'lower than',
  condition_builder_comparator_lower_than_or_equals: 'lower than or equals',
  condition_builder_comparator_after: 'after',
  condition_builder_comparator_on_or_after: 'on or after',
  condition_builder_comparator_before: 'before',
  condition_builder_comparator_on_or_before: 'on or before',
  condition_builder_logical_and: 'And',
  condition_builder_logical_or: 'Or',

  /* build:AppShell */
  dev_mode: 'Dev mode',
  expand_navigation: 'Expand navigation',
  collapse_navigation: 'Collapse navigation',
  switch_to: 'Switch to…',
  collapse_search: 'Collapse search',

  /* build:BranchButton */
  branch_with_no_changes: '{0} with no changes',
  branch_with_no_potential_conflicts: '{0} with no potential conflicts and {1} unmerged changes',
  branch_with_potential_conflicts: '{0} with potential conflicts',

  /* build:BackgroundPicker */
  style: 'Style',
  color: 'Color',
  opacity: 'Opacity',
  file_url: 'File URL',
  size: 'Size',
  position: 'Position',
  repeat: 'Repeat',
  image_preview: 'Image preview',
  direction: 'Direction',
  color_stops: 'Color stops',
  add_stops: 'Add stops',
  gradient_preview: 'Gradient preview',
  location: 'Location',
  delete_stop: 'Delete stop',
  edit_background_picker_label: 'Edit {0}',
  automatic: 'Automatic',
  transparent: 'Transparent',
  solid_color: 'Solid color',
  image: 'Image',
  linear_gradient: 'Linear gradient',
  radial_gradient: 'Radial gradient',
  conic_gradient: 'Conic gradient',
  auto: 'Auto',
  cover: 'Cover',
  contain: 'Contain',
  center: 'Center',
  top: 'Top',
  right: 'Right',
  left: 'Left',
  bottom: 'Bottom',
  top_left: 'Top left',
  top_right: 'Top right',
  bottom_right: 'Bottom right',
  bottom_left: 'Bottom left',
  no_repeat: 'No repeat',
  repeat_image: 'Repeat',
  repeat_x: 'Repeat x',
  repeat_y: 'Repeat y',
  space: 'Space',
  round: 'Round',
  file_url_error: 'Enter a valid URL',
  color_preview: 'Color preview',

  /* build:Lifecycle */
  parallel: 'Parallel',
  stage: 'Stage',
  process: 'Process',
  alternate_stage: 'Alternate stage',
  add_stage: 'Add stage',
  add_process: 'Add process',
  add_alternate_stage: 'Add alternate stage',
  stage_name: '{0} stage',
  process_name: '{0} process',
  step_name: '{0} step',
  item_error: '{0} error',
  step_name_error: '{0} step has configuration error',
  stage_name_error: '{0} stage has configuration error',
  process_name_error: '{0} process has configuration error',
  wait_for_user_action: '{0} - wait for a user action',
  resolve_case: '{0} - resolve case',

  /* build:ItemLibrary */
  collect_info: 'Collect info',
  decision: 'Approve/Reject',
  send_email: 'Send email',

  /* build:FlowModeller */
  add_node: 'Add node',
  search_nodes: 'Search nodes',
  delete_step: 'This step has multiple outcomes, are you sure want to delete this step?',
  delete_decision_step:
    'Select outcome that you want to retain. The remaining highlighted outcomes will be deleted',
  delete_step_title: 'Delete step',
  delete_step_outcome: 'Outcome to keep',
  delete_all_outcomes: 'None (delete all outcomes)',
  delete_step_error: 'This step can\'t be deleted as the outcome selected has a "Go to" step.',
  delete_referenced_step_error:
    'This step can\'t be deleted as it is referenced by a "Go to" step.',
  delete_connector_error:
    'Connector cannot be deleted unless Goto step is deleted from all branches',
  close_panel: 'Close panel',
  use_arrow_keys: 'Use arrow keys to navigate between nodes',
  end: 'End',
  step_has_goto_references:
    'You cannot delete this step, as it is referenced as a "Go to" action within the following steps:',
  remove_goto_references: 'To delete this step, remove all "Go to" references to this step.',

  /* build:ProcessModeller */
  process_node_task: 'Task',
  process_node_assignment: 'Assignment',
  process_node_automation: 'Automation',
  process_node_decision: 'Decision',
  process_node_goto: 'Go to',
  process_node_subprocess: 'Subprocess',
  process_node_wait: 'Wait',
  process_route_to: 'Route to',
  process_goes_to_prefix: 'Goes to',
  process_connector_submit: 'Submit',
  process_connector_default: 'Default',
  process_connector_otherwise: 'Otherwise',
  process_decision_description: 'Adjust the conditions using the property panel',
  process_icon_assignment: 'Assignment case type',
  process_icon_automation: 'Automation object',
  process_icon_decision: 'Decision step logic',
  process_icon_goto: 'Goto case type',
  process_icon_subprocess: 'Case process',
  process_icon_wait: 'Wait case type',

  /* build:FieldReference */
  applies_to: 'Applies to',
  path: 'Path',
  current_context: 'Current context: {0}',
  fieldref_open_close: 'Arrow down to open, press escape to close.',
  fieldref_search_instructions: 'Start typing to search',
  fieldref_open_list_button_a11y: 'Open field reference list',
  fieldref_close_list_button_a11y: 'Close field reference list',

  /* build:DynamicInput */
  constant_description: 'The value that is entered here will not change.',
  expression_description: 'Set this value using advanced custom logic.',
  rule_description: 'Set this value using a Rule.',
  constant_label: 'Static ({0})',
  expression_label: 'Expression',
  rule_label: 'Source from Library',
  field_reference_label: 'Source from a Field',
  field_reference_description: 'Set this value by referencing a Field.',
  configuration_settings_label: 'Subscriber Settings',
  configuration_settings_description: 'Set this value using Configuration Settings.',
  value_type: 'Value type',
  dynamicInput_format_Text: 'Text',
  'dynamicInput_format_Text (paragraph)': 'Text (paragraph)',
  dynamicInput_format_Boolean: 'Boolean',
  dynamicInput_format_Currency: 'Currency',
  dynamicInput_format_Percentage: 'Percentage',
  dynamicInput_format_Integer: 'Integer',
  dynamicInput_format_Decimal: 'Decimal',
  dynamicInput_format_Phone: 'Phone',
  dynamicInput_format_DateTime: 'DateTime',
  dynamicInput_format_Date: 'Date',
  dynamicInput_format_Time: 'Time',

  /* build:Workbench */
  zoom_level: 'Zoom level',
  close_configuration_panel: 'Close configuration panel',

  /* build:ObjectSelect */
  clear_object_summary: 'Clear {0} selection',
  create_in_new_tab: 'Create new, opens in new tab',
  input_tree_contextual_label: 'of',
  input_tree_error: 'has error',
  parameters: 'Parameters',

  /* build:ExpressionBuilder */
  expression_editor: 'Expression editor',
  output_parameters: 'Output parameters',
  input_parameters: 'Input parameters',

  /** build: Expression */
  expression_input: 'Expression input',

  /* build:MobileBuildSummary */
  no_app_build: 'There is no app build',
  build_app: 'Build app',
  build_in_progress: 'Building…',
  rebuild_app: 'Rebuild app',
  download_app: 'Download app',
  qr_code_not_available: 'No QR code available yet',
  qr_code: 'QR code',

  /* build: Automation */
  expand_all: 'Expand all',
  collapse_all: 'Collapse all',
  expand_steps: 'Expand all steps',
  collapse_steps: 'Collapse all steps',
  expand_step: 'Expand step {0}',
  collapse_step: 'Collapse step {0}',
  expanded_step: 'Expanded step {0}',
  collapsed_step: 'Collapsed step {0}',
  add_step: 'Add step',
  generate_comments: 'Generate comments',
  action_set: 'Set',
  action_when: 'When',
  action_append: 'Append',
  action_call: 'Call',
  action_create: 'Create',
  action_for_each: 'For each',
  action_exit: 'Exit',
  action_return: 'Return',
  action_remove: 'Remove',
  action_error_handler: 'Error handler',

  /* wss:AppHeader */
  app_header_notifications_empty: 'No notifications',
  app_header_notifications_loading: 'Loading notifications',
  open_app_header_notifications: 'Open notifications',
  open_app_header_drawer: 'Open navigation menu',
  hello_name: 'Hello, {0}',

  /* tools: PreviewShell */
  preview_frame: 'Preview frame',
  open_in_new_window_text: 'Open in new window',
  more_options: 'More options',
  dev_tools: 'dev tools',

  /* tools: DevTools */
  active_session_info: 'Debugging for this session is active in another window',
  continue_debugging: 'Continue debugging',

  /* lists-repeating-structures: Toolbar */
  delete_group: 'Delete group',
  add_group: 'Add group',
  add_sort: 'Add sort',
  drag_to_reorder: 'Drag to reorder',
  drag_to_reorder_field: 'Drag to reorder {0}',

  /* lists-repeating-structures: Map */
  view_in_google_maps: 'View in Google Maps',
  location_marker: 'Location marker {0}',

  /* Launchpad: IconTiles */
  action_task: 'Action task',
  task_object: 'Task object',
  view_rule: 'View rule',
  system_rule: 'System rule',
  record_rule: 'Record rule',
  portal_rule: 'Portal rule',
  persona_rule: 'Persona rule',
  permission_rule: 'Permission rule',
  live_data_rule: 'Live data rule',
  integration_system_rule: 'Integration system rule',
  insight_rule: 'Insight rule',
  field_rule: 'Field rule',
  data_page_rule: 'Data page rule',
  connector_rule: 'Connector rule',
  configuration_rule: 'Configuration rule',
  authenticate_rule: 'Authenticate rule',
  when_logic: 'When logic',
  validation_logic: 'Validation logic',
  function_logic: 'Function logic',
  decision_step_logic: 'Decision step logic',
  case_wait: 'Case wait object',
  case_stage: 'Case stage object',
  case_sla: 'Case SLA object',
  case_process: 'Case process object',
  case_go_to: 'Case go-to object',
  case_object: 'Case object',
  set_automation: 'Set automation',
  return_automation: 'Return automation',
  for_each_automation: 'For each automation',
  call_automation: 'Call automation',
  append_automation: 'Append automation',
  automation_object: 'Automation object',
  ai_object: 'AI object',

  /* authoring-ui-views: AdditionalInformation */
  additional_information: 'Additional Information',
  field_picker_label: 'Field',
  field_picker_placeholder: 'Select Field...',
  editor_loading_message: 'Loading editor...',

  /* authoring-ui-views: FieldLabelInput */
  custom_label: 'Custom label',
  custom_caption: 'Custom caption',

  /* authoring-ui-views: TargetClassLabelInput */
  add_label: 'Add label',
  custom_add_label: 'Custom add label',

  /* authoring-ui-views: Instructions */
  instruction_text_label: 'Instruction text',

  /* authoring-ui-views: AddParagraphModal */
  paragraph_already_exists_error: 'Paragraph rule with name {0} already exists',
  paragraph_create_modal_heading: 'New Dynamic Text',
  paragraph_update_modal_heading: 'Edit {0}',
  paragraph_name_label: 'Name',
  paragraph_text_content_label: 'Text',
  shared_rule: 'This is a shared Rule.',
  creating_new_rule: 'Creating new Rule...',
  updating_rule: 'Updating Rule...',
  unsupported_rule_type_label: 'Unsupported ruleType',
  unsupported_rule_type_description: "Unsupported rule type: '{0}'",
  create_new_record_failed: 'Create new record failed',

  /* authoring-ui-views: DataPage format */
  override_parameters: 'Override parameters',

  /* authoring-ui-views: ContentPicker */
  component_not_found_error:
    "The '{0}' component is missing. Check that it is added to the application.",
  component_not_found_error_with_type: "No components of type '{0}' were found.",
  component_not_found_error_with_subtype: "No components of subtype '{0}' were found.",
  component_not_found_error_with_type_and_subtype:
    "No components of type '{0}' and subtype '{1}' were found.",
  component_missing_error_status:
    "The '{0}' component is missing. Add it to the application or use the default component in the property panel.",
  field_type_updated_error_status:
    'The type of "{0}" was updated. Delete it or update it in the property panel.',
  field_type_updated_error: 'The type of "{0}" was updated.',

  /* authoring-ui-views: useDrillIn */
  field_does_not_exist_error:
    'Field "{0}" was not found. Check if it still exists and is marked as relevant.',

  /* authoring-ui-views: DynamicContentPicker */
  configure_item: 'Configure {0}: {1}',
  data_page_call_error: 'Error occurred calling the data page. Data for {0} cannot be retrieved.',
  item_not_in_data_page: '{0} no longer exists in the data page.',

  /* authoring-ui-views: SyncTabsFromDetails */
  sync_tabs_additional_info_enabling: 'Enabling reveals the same tabs from the Full Page View.',
  sync_tabs_additional_info_tabs: 'Otherwise, the following tabs will be shown:',

  /* authoring-ui-views: LocationDetails */
  location_field_label: 'Location field',

  /* authoring-ui-views: AddMenu */
  create_new_item: 'Create new {0}',

  /* authoring-ui-views: GroupBy */
  group_by_label: 'Group by',
  group_by_add_new: 'Add new group-by to {0}',
  group_by_default: 'Default',
  group_by_configure_group: 'Configure group: {0}',
  group_by_date_function: 'Date function',
  group_by_remove_from: 'Remove {0} from {1}',

  /* authoring-ui-views: TimelineDetails */
  timeline_details_date_field: 'Date field',
  timeline_details_title: 'Title',

  /* authoring-ui-views: Gallery */
  gallery_card_header: 'Card header',

  /* authoring-ui-views: ThemeDesigner */
  warning_color: 'Warning - {0}',
  color_contrast_warning: 'Fails WCAG 2.1 AA contrast when paired with these colors:',
  color_contrast_warning_non_solid:
    'WCAG 2.1 AA contrast must be manually verified when paired with non-solid colors:',
  has_compliance_warning: '{0} - has compliance warning',
  compliance_warning: 'Compliance warning',
  gradient_warning: 'WCAG 2.1 AA contrast must be manually verified for a non-solid color.',
  advanced_settings_toggle_btn: '{0} advanced settings',
  color_swatch_btn_label: 'Set {0} to {1}',
  theme_preview_title: 'Theme Preview',
  default_font_info: 'Selection will override app header and heading fonts',
  custom_font_family: '{0} font family name',
  custom_font_family_error: "Font family can't be empty",
  helper_text_position_warning: 'Will force all forms to single column layout',
  supplemental_color_additional_info:
    'Supplemental colors control data visualization color series and table grouping indicators. ' +
    'Additionally, if enabled in this theme, they may also affect Cases and Data Objects, ' +
    'Field group lists, and Utility widgets.',

  /* authoring-ui-views: EditFullObject */
  fields_to_highlight: 'Fields to highlight',
  first_field: 'First field',
  first_n_fields: 'First {0} fields',
  learn_about_primary_fields: 'Learn more about Primary Fields',
  show_lifecycle: 'Show Lifecycle',
  use_only_primary_fields: 'Sync to Primary Fields',
  use_only_primary_fields_info:
    '"Use only Primary Fields" pre-populates and links the Full Object Display Rule with the Primary Fields configured in the Data Model tab.',
  new_tab_heading: 'New Tab',
  creating_tab: 'Creating Tab...',
  create_tab_failure_message: 'Failed to create a Tab',

  /* authoring-ui-views: EditFields */
  loading_configure_dialog: 'Loading configure dialog',

  /* authoring-ui-views: Explore data configuration */
  insight_datapage_picker_limited_features:
    'The selected data page is not queryable and supports only limited features.',
  data_page: 'Data page',

  /* authoring-ui-views: InsightContextFilters */
  delete_parameter_filter: 'Delete parameter filter',
  insight_field_applied_on: 'Insight field applied on',
  please_fill_the_required_fields: 'Please fill the required fields',
  please_fix_the_logic_condition: 'Please fix the advanced condition',
  system_pages: 'System pages',
  value_cannot_be_blank: 'Value cannot be blank',
  valid_number_within_range: 'Enter a valid number between {0} - {1}',
  expected_value: 'Expected value {0}',
  invalid_value: 'Invalid value',
  filter_value: 'Filter value',

  /** authoring-ui-views: LandingPageFilters */
  picklist_source_type_as_defined_on_property: 'As defined on property',
  picklist_source_type_data_page: 'Data page',
  data_source_type: 'Data source type',
  display_label: 'Display label',
  field_does_not_exist_on_the_selected_source: "Field doesn't exist on the selected source",
  failed_to_validate_source: 'Failed to validate source',
  source_used_for_picklist_values: 'Source used for picklist values',
  filter_mappings: 'Filter mappings',
  filter_mappings_additional_info:
    'Configure how the filter is applied on each Insight. The filter is not applied on Insights for which no mapping is configured.',
  add_mapping: 'Add mapping',
  select_insight: 'Select Insight',
  from_value: 'From {0}',
  to_value: 'To {0}',

  /** authoring-ui-views: Runtime Dashboards */
  private_only: 'Private - Only you',
  shared_users_with_access: 'Shared - Users with access',
  public_all_users: 'Public - All users',
  access_group: 'Access group',
  dashboard_visibility: 'Visibility',
  dashboard_shared_with: 'Shared with',
  dashboard_private: 'private',

  /** authoring-ui-views: ViewLabelInput */
  show_heading: 'Show heading',
  internal_use: 'For internal use',
  internal_use_message:
    'This name is used to identify the View and will not be shown to application users.',
  cannot_be_empty: 'View name cannot be empty.',

  /* authoring-ui-views: CardDetails */
  'Default layout': 'Default layout',
  Grid: 'Grid',
  Stacked: 'Stacked',

  /* business-intelligence: General */
  insight: 'Insight',
  invalid_data_configuration: 'Invalid data configuration',
  something_went_wrong: 'Something went wrong.',

  /* business-intelligence: InsightPanel */
  hide_icons_additional_info_first_sentence:
    'To ensure accessibility standards are met, color cannot be the only way of distinguishing information.',
  hide_icons_additional_info_second_sentence:
    'Visit {0} to learn more about the related accessibility guidelines.',
  wcag: 'WCAG',

  /* business-intelligence: Trend indicators - current time period */
  this_year: 'This year',
  this_quarter: 'This quarter',
  this_month: 'This month',
  this_week: 'This week',
  this_day: 'This day',
  this_hour: 'This hour',
  this_minute: 'This minute',
  this_second: 'This second',

  over_time_period: 'over {0}',
  since_time_period: 'since {0}',
  in_current_time_period: 'in {0}',

  /* business-intelligence: Trend indicators - Increase cases */
  increased_by_value_over_time_period: 'Increased by {0} over {1}',
  increased_by_value_since_time_period: 'Increased by {0} since {1}',
  increased_by_value_in_current_time_period: 'Increased by {0} in {1}',
  increased_by_value_today: 'Increased by {0} today',

  /* business-intelligence: Trend indicators - Decrease cases */
  decreased_by_value_over_time_period: 'Decreased by {0} over {1}',
  decreased_by_value_since_time_period: 'Decreased by {0} since {1}',
  decreased_by_value_in_current_time_period: 'Decreased by {0} in {1}',
  decreased_by_value_today: 'Decreased by {0} today',

  /* business-intelligence: Trend indicators - No change cases */
  no_change_over_time_period: 'No change over {0}',
  no_change_since_time_period: 'No change since {0}',
  no_change_in_current_time_period: 'No change in {0}',
  no_change_today: 'No change today',
  /* business-intelligence: Date functions */
  date_function_year: 'Year',
  date_function_quarter: 'Quarter',
  date_function_month: 'Month',
  date_function_week: 'Week',
  date_function_day: 'Day',
  date_function_hour: 'Hour',
  date_function_minute: 'Minute',
  date_function_month_of_year: 'Month of year',
  date_function_day_of_month: 'Day of month',
  date_function_day_of_week: 'Day of week',
  date_function_hour_of_day: 'Hour of day',

  /* business-intelligence: Aggregations */
  aggregation_count: 'Count',
  aggregation_distinct_count: 'Distinct count',
  aggregation_total: 'Total',
  aggregation_average: 'Average',
  aggregation_minimum: 'Minimum',
  aggregation_maximum: 'Maximum',
  aggregation_sum: 'Sum',

  /* business-intelligence: Drilldown */
  drilldown_footer_label: '{0} for {1}',

  /* business-intelligence: Legend */
  select_chart_data_view: 'Select chart data view',
  toggle_chart_element_visibility: 'Toggle chart element visibility',
  chart_legend_items: 'Chart legend items',

  /* authoring-ui-views: AddButton */
  add_to: 'Add to {0}',

  /* authoring-ui-views: ViewPicker */
  namespace: 'Namespace',

  /* authoring-ui-views: WhenPicker */
  decision_rule: 'Decision',
  when_rule: 'When',
  invalid_rule: 'This Rule is no longer valid. Ensure it exists in the system.',
  invalid_rule_non_relevant_record:
    'This Rule is no longer valid. Ensure it exists in the system and is marked as a relevant record.',

  /* authoring-ui-views: Preview */
  infinity_stack_overflow_error:
    'This View is currently configured to include itself. Please change configuration to prevent error.',
  preview_failed: 'Preview failed',
  preview_not_available: 'Preview not available',

  /** authoring-decision-table */
  decision_table_description: 'Set conditions to capture decision logic.',
  decision_table_empty_state: 'Add columns to start building the decision table',
  decision_table_add_column: 'Add column',
  decision_table_add_columns: 'Add columns',
  decision_table_edit_columns: 'Edit columns',
  decision_table_add_to_library: 'Add to library for reuse',
  decision_table_source_label: 'Column',
  decision_table_comparator_label: 'Comparator',
  decision_table_add_row: 'Add Row',
  decision_table_delete_row: 'Delete Row',
  decision_table_cancel: 'Cancel',
  decision_table_submit: 'Submit',
  decision_table_help_text:
    'Add fields as columns to create decision table structure and then input values to capture the business rules and conditions as decision logic to return appropriate values.',
  decision_table_valid_column: 'Select a valid field',
  decision_table_repeated_column: 'Repetition of fields is not supported',
  decision_table_valid_comparator: 'Select a valid comparator',
  decision_table_if: 'if',
  decision_table_else_if: 'else if',
  decision_table_else: 'Otherwise',
  decision_table_return: 'Return',
  decision_table_equal: 'Equal to',
  decision_table_equal_header: 'is equal to',
  decision_table_not_equal: 'Not equal to',
  decision_table_not_equal_header: 'is not equal to',
  decision_table_greater_than: 'Greater than',
  decision_table_greater_than_header: 'is greater than',
  decision_table_less_than: 'Less than',
  decision_table_less_than_header: 'is less than',
  decision_table_greater_than_or_equal: 'Greater than or equal to',
  decision_table_greater_than_or_equal_header: 'is greater than or equal to',
  decision_table_less_than_or_equal: 'Less than or equal to',
  decision_table_less_than_or_equal_header: 'is less than or equal to',
  decision_table_between: 'Between',
  decision_table_between_header: 'is between',
  decision_table_from: 'From',
  decision_table_from_header: 'is from',
  decision_table_custom_range_1: 'Custom range 1',
  decision_table_custom_range_1_header: 'is in custom range 1',
  decision_table_custom_range_2: 'Custom range 2',
  decision_table_custom_range_2_header: 'is in custom range 2',

  /** studio-dx-components: AIAssistant */
  ai_assistant: 'AI assistant',

  /** studio-dx-components: AppInfo */
  app_info_main_branch: 'Main',
  app_info_create_branch: 'Create branch',
  app_info_open_branch: 'Open branch',
  app_info_application_version: '{0} - v. {1}',

  /** studio-dx-components: Preview */
  app_preview_loading: 'Loading preview...',
  app_preview_ready: 'Your preview is ready.',
  app_preview_failed: 'Failed to load preview.',
  app_open_preview: 'Open preview',
  app_view_errors_in_preview: 'View errors',

  /** studio-dx-components: Expression */
  expression_error_incorrect_data_type: 'Incorrect datatype',
  expression_error_with_data_and_object_type: 'Incorrect type, {0} of type {1} is required',
  expression_error_with_data_type: 'Incorrect type, {0} is required',
  prompt_scope: 'Scope',
  prompt_type: 'Type',
  expression_wait_message:
    'Expression is being validated. Please wait a little and then click Save/Submit again.',
  expression_general_error: 'Error Occurred in Expression Component',
  expression_datapage_general_error: 'Error occurred on fetching {0}',
  expression_allowed_rules_error: 'Only {0} are allowed',
  expression_empty_error: 'Cannot be blank',

  /** studio-dx-components: ConditionBuilder */
  cb_invalid_leaf_condition: 'Invalid leaf condition',
  cb_invalid_operand: 'Invalid operand',
  cb_expression_node_null: 'Expression node cannot be null or undefined',
  cb_expression_node_missing: 'Expression node must have expressions',
  cb_invalid_unary_expression: 'Invalid unary expression',
  cb_invalid_group_expression: 'Invalid group expression',

  /** studio-dx-components: SimpleList */
  simplelist_group_modal_heading: 'Delete group?',
  simplelist_group_modal_content:
    'Deleting the group will remove its contents. Are you sure you would like to delete the group?',
  simplelist_add: 'Add',
  simplelist_add_item: 'Add item',
  simplelist_add_group: 'Add group',
  simplelist_configure_item: 'Configure item: {0}',
  simplelist_configure_group: 'Configure group: {0}',

  /** DX components: Dashboard templates */
  please_apply_promoted_filters_to_load_data: 'Please apply promoted filters to load data.',

  /* dx-components: ui-inspector */
  ui_inspector: 'UI Inspector',
  ui_inspector_iframe_title: '{0} - UI Inspector enabled',
  ui_inspector_metadata: 'Metadata',
  ui_inspector_quick_info: 'Quick info',
  ui_inspector_field_metadata: 'Field metadata',

  /* AgentTracer */
  ai_tracer: 'AI tracer',
  agent_tracer_select_an_event: 'Select an event',
  agent_tracer_total_processing_time: 'Total processing time',
  agent_tracer_total_tokens: 'Total tokens',
  agent_tracer_total_tool_calls: 'Total tool calls',
  agent_tracer_total_llm_calls: 'Total LLM calls',
  agent_tracer_agent_configuration: 'Agent configuration',
  agent_tracer_agent_instruction: 'Agent instruction',
  agent_tracer_user_query: 'User query',
  agent_tracer_tools_to_be_invoked: 'Tools to be invoked',
  agent_tracer_inputs: 'Inputs',
  agent_tracer_output: 'Output',
  agent_tracer_prerequisites: 'Prerequisites',
  agent_tracer_pega_context: 'Pega context',
  agent_tracer_data_from_all_sources: 'Data sources',
  agent_tracer_complete_data_source: 'Complete data source',
  agent_tracer_conversation_trace: 'Conversation trace',

  /* Expression Builder */
  generating_explanation: 'Generating explanation',
  explanation_generated: 'Expression explanation generated',
  clear_explanation: 'Clear explanation',
  describe_expression: 'Describe Expression requirements',
  generating_expression: 'Generating Expression',
  generated_explanation: 'Generated explanation',
  generated_expression: 'Generated Expression',
  expression_generated: 'Expression generated',
  expression_builder: 'Expression Builder',
  open_expression_builder: 'Open Expression Builder',
  library: 'Library',

  /* Collaboration */
  Collaborators: 'Collaborators',
  collaborators: 'collaborators',
  view_collaborators: 'View collaborators',
  close_collaborators: 'Close collaborators',
  collaborator_is_mode: '{0} is {1}'
};
